<template>
    <div>
        <Cms ref="categories" model="categories" driver="builder" is-data v-show="false" v-model="categoryData" :searchParams="categorySearchParams"/>
        <Cms
            ref="headerCms"
            model="product-listing-header-section"
            :url="`/index/category${category.seo_name}/shop-all`"
            :search-params="searchParams"
            driver="builder"
            :components="getBuilderComponents({include: [ seoCopyInit, categoryTilesInit ]})"
            :injectedData="{ category: {...category, child_category: productListingCategories}, ...productListingCategories }"
            :injectedContext="{}"
            is-section
        />
        <CategoryTiles
            v-if="!headerCmsHasBuilderContent && !isLoadingBuilderContent"
            :category="{...category, child_category: productListingCategories}"
            :banner="{
                banner_media: {
                    bg_color: 'rothcoWhite'
                },
            }"
        />
        <product-tiles
            :search-spring-data="searchSpringResults"
            :handle-sort="handleSort"
            :handle-filter="handleFilter"
            v-model:sort-option="defaultSort"
            :handle-pagination="handlePagination"
            :paginationKey="paginationKey"
            :showBreadcrumbs="true"
            :category="category"
        />
        <!-- :breadcrumbs="breadcrumbs" -->
        <Cms
            ref="footerCms"
            model="product-listing-footer-section"
            :url="`/index/category${category.seo_name}/shop-all`"
            :search-params="searchParams"
            driver="builder"
            :components="getBuilderComponents()"
            :injectedData="{ category, ...childCategories }"
            :injectedContext="{}"
            is-section
        />
        <SeoCopy 
            v-if="!footerCmsHasBuilderContent"
            :category="category"
        />
    </div>
</template>
<script setup lang="ts">
    import { ref, reactive, computed, watch, onMounted, provide, type PropType, inject } from "vue";

    import Layout from "@/Shared/Layout.vue";
    import Cms from "@/components/Cms.vue";
    // import { route } from "ziggy-js";
    import { toRefs } from "vue";
    // import { registeredComponents } from "../../product-listing-page-init-builder";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { categoryTilesInit } from "@/helpers/builder-init/CategoryTiles";
    import { seoCopyInit } from "@/helpers/builder-init/SeoCopy";
    import { type CategorySearch } from "@interfaces/SearchSpringCategorySearch";
    import SearchSpringApi from "@/helpers/api/SearchSpringAPI.ts";
    import { useCategorySearch } from "@/helpers/composables/searchSpringApi";
    import ProductTiles from "@/components/ProductTiles.vue";
    import CategoryTiles from "@/components/CategoryTiles.vue";
    import SeoCopy from "@/components/SeoCopy.vue";
    import { storeToRefs } from "pinia";
    import { useGenericStore } from "@/store/genericStore";
    let route = inject('route');
    let props = defineProps({
        category: {
            type: Object as PropType<any>,
            required: true
        },
    });    

    let childCategories = computed(() => {
        return (
            props.category?.child_category?.reduce((acc: any, childCategory: any) => {
                acc[childCategory.seo_name.replaceAll(/\-/g, "_")] = {
                    name: childCategory.category_name,
                    seo_name: childCategory.seo_name
                };
                return acc;
            }, {}) ?? {}
        );
    });

    const headerCms = ref(null);
    const headerCmsHasBuilderContent = computed(()=>{
        let content = typeof headerCms.value?.hasBuilderContent == 'function' ? headerCms.value?.hasBuilderContent() : headerCms.value?.hasBuilderContent;
        return Object.keys(content ?? {}).length;
    })
    const isLoadingBuilderContent = computed(()=>(headerCms.value?.isLoadingContent));
    const footerCms = ref(null);
    const footerCmsHasBuilderContent = computed(()=>{
        return typeof footerCms.value?.hasBuilderContent == 'function' ? footerCms.value?.hasBuilderContent() : footerCms.value?.hasBuilderContent;
    })
    
    const searchParams = computed(()=>{
        return {
            'data.seoName.$eq': props.category.seo_name
        }
    })
    const searchSpringApi = new SearchSpringApi();
    let {
        searchSpringResults,
        handleSort,
        handleFilter,
        handlePagination,
        defaultSort,
        paginationKey,
        key
    } = useCategorySearch({
        searchSpringApi,
        category: props.category
    });

    const categoryData = ref([]);
    const categorySearchParams = computed(()=>{
        return {
            "data.name.$in": [
                props.category.seo_name,
                ...(props.category.child_category?.map((cat) => cat.seo_name) ?? [])
            ]
        } 
    })

    const { state:parentCategoryData} = storeToRefs(useGenericStore(`categoryData-${props.category.seo_name}`));
    parentCategoryData.value = computed(()=>{
        return categoryData.value.find((cat)=>cat.name == props.category.seo_name) ?? {'seoText': ''};
    })

    const childCategoryData = computed(()=>{
        return categoryData.value?.filter((cat)=>cat.name != props.category.seo_name) ?? [];
    })
    
    const productListingCategories = computed(()=>{
        return props.category.child_category.map((childCategory)=>{
            let builderContent = childCategoryData.value.find(cat => cat.name == childCategory.seo_name) ?? null;
            return {
                ...childCategory,
                image: builderContent?.plpImage || childCategory.main_image,
                url: route(`category.shop-all`, [childCategory.seo_name]),
                alt: childCategory.category_name
            }
        })
    })
</script>
